"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchResultClear = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ManagerSearchResultClear = styled_components_1.default.a `
  position: relative;
  left: 260px;
  color: rgba(144, 187, 224, 1);
`;
//# sourceMappingURL=search-filter-clear.js.map